import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import styles from './link-button.css'

const LinkButton = ({ label, disabled, onClick }) => (
  <div styleName={`link-button ${disabled ? 'is-disabled' : ''}`} onClick={disabled ? null : onClick}>
    {label}
  </div>
)

LinkButton.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.string,
  onClick: PropTypes.func,
}

export default CSSModules(LinkButton, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/link-button/link-button.js
 **/